// extracted by mini-css-extract-plugin
module.exports = {"zoomInput":"Zoom_zoomInput__1EOLa","button":"Zoom_button__3Wuag","buttonIcon":"Zoom_buttonIcon__2EMD7"};